import React from 'react';
import SessionActions from 'agent_portal/actions/SessionActions';
import { PortalNav } from 'shared/containers/portal_layout';

const AgentPortalNav = ({ currentEmployment }) => (
  <PortalNav>
    <PortalNav.NavLink to="/a/portal/dashboard" icon="home" label="Home" />
    {currentEmployment.providerId && (
      <PortalNav.NavLink
        to={`/a/portal/providers/${currentEmployment.providerId}/profile`}
        icon="user"
        label="Profile"
      />
    )}
    <PortalNav.NavLink to="/a/portal/current_agent/edit" icon="gear" label="Settings" />
    <PortalNav.NavButton
      id="logout"
      onClick={SessionActions.signOutAgent}
      icon="exit"
      label="Logout"
    />
  </PortalNav>
);

export default AgentPortalNav;
